import Vue from 'vue'
import { getBillList, editBill,queryInvoiceApplyInfo,updateInvoiceStatusAndCourier} from '@/api/bill'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const bill = {
	state: {
		loading: false
	},

	mutations: {

	},

	actions: {

		GetBillList({ commit }, record) {
			return new Promise((resolve, reject) => {
				getBillList(record).then(response => {
					console.log(response)
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
		EditBill({ commit }, record) {
			return new Promise((resolve, reject) => {
				editBill(record).then(response => {
					console.log(response)
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
    QueryInvoiceApplyInfo({ commit }, record) {
      return new Promise((resolve, reject) => {
        queryInvoiceApplyInfo(record).then(response => {
          console.log("加载数据为:"+response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateInvoiceStatusAndCourier({ commit }, record) {
      return new Promise((resolve, reject) => {
        updateInvoiceStatusAndCourier(record).then(response => {
          console.log("加载数据为:"+response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }

	}
}

export default bill
